import { render } from "./Recaptcha.vue?vue&type=template&id=0876dc04"
import script from "./Recaptcha.vue?vue&type=script&lang=ts"
export * from "./Recaptcha.vue?vue&type=script&lang=ts"
script.render = render

export default script